import { Col, Container, Row } from "reactstrap";
import BlogBoxGrid from "./BlogBoxGrid";
import BlogBoxList from "./BlogBoxList";
import { LearningListTitle, LearningTitle } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import LearningFilter from "../common/learningFilter";

const LearningListContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={LearningListTitle} parent={LearningTitle} />
      <Container fluid>
        <Row>
          <Col xl="9" className="xl-60 order-xl-0 order-1 box-col-12">
            <Row>
              <BlogBoxList />
              <BlogBoxGrid />
            </Row>
          </Col>
          <LearningFilter />
        </Row>
      </Container>
    </>
  );
};
export default LearningListContainer;
